<template>
    <div id="refPage">
        <!--loader - message--->
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
       
        <div class="whiteBG mb-4">
            <section class="blockElement mainBanner" v-if="referList.length == 0">
                <div class="containerarea">
                    <div class="inner-banner-custom row align-items-center">
                        <div class="col-12 col-md-6 left-block wow bounceInDown">
                            <h1>{{$t('refer_Refera')}}<span>{{$t('refer_friend')}}</span></h1> 
                            <p>{{$t('refer_opportunity')}}</p> 
                            <div class="buttonBanner d-flex align-items-center mt-5" v-if="parseInt(get_user.verified_status) >= 1 && parseFloat(get_user.profile.total_deposit) > 0">
                                <button class="cr-btn hvr-sweep-to-top greenBG gTagRegister" @click.prevent="toDivElement('email0')">{{$t('refer_Refernow')}}</button>
                            </div>
                            <div class="buttonBanner d-flex align-items-center mt-5" v-else>
                                 <!-- <button class="cr-btn hvr-sweep-to-top redBG gTagRegister">{{$t('refer_errorReferal')}}</button> -->
                                 <button class="gTagRegister RegisterAlert">{{$t('refer_errorReferal')}}</button>
                            </div>
                        </div> 
                        <div class="col-12 col-md-6 right-block  wow bounceInRight">
                            <div class="bannerSupport">
                                <img src="/static/fxView/images/refer-a-friend.png" alt="Banner" class="bull">
                            </div>
                        </div>
                    </div>
                </div>
            </section> 
            <section class="blockElement works-section blockTwo overflow-hidden mt-4" v-if="referList.length == 0">
                <div class="containerarea">
                    <div class="row justify-content-center">
                        <div class="col-12 text-center">
                            <div class="main-title flipInX wow">
                                <h2 class="mb-3">{{$t('refer_howorks')}}</h2> 
                                <p>{{$t('refer_everyclient')}}</p>
                            </div>
                        </div>
                    </div> 
                    <div class="row mt-5 justify-content-center minTrade">
                        <div class="col-12 col-md-3 text-center wow flipInX">
                            <div class="card d-block border-0 customHover py-3 px-3">
                                <span class="number">1</span> 
                                <div class="card-body p-2 mt-3">
                                    <p class="card-title">{{$t('refer_stepmsg1')}}</p>
                                </div>
                            </div>
                        </div> 
                        <div class="col-12 col-md-3 text-center wow flipInX">
                            <div class="card d-block border-0 customHover py-3 px-3">
                                <span class="number">2</span> 
                                <div class="card-body p-2 mt-3">
                                    <p class="card-title">{{$t('refer_stepmsg2')}}</p>
                                </div>
                            </div>
                        </div> 
                        <div class="col-12 col-md-3 text-center wow flipInX">
                            <div class="card d-block border-0 customHover py-3">
                                <span class="number">3</span> 
                                <div class="card-body p-2  mt-3">
                                    <p class="card-title">{{$t('refer_stepmsg3')}}</p>
                                </div>
                            </div>
                        </div> 
                        <div class="col-12 col-md-3 text-center wow flipInX">
                            <div class="card d-block border-0 customHover py-3">
                                <span class="number">4</span> 
                                <div class="card-body p-2 mt-3">
                                    <p class="card-title">{{$t('refer_stepmsg4')}}</p>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div class="row mt-3 justify-content-center d-flex">
                        <div class="col-12 text-center">
                            
                        </div>
                    </div>
                </div>
            </section>  
            <div class="stepForm" v-if="parseInt(get_user.verified_status) >= 1 && parseFloat(get_user.profile.total_deposit) > 0">
                <div class="mainTitle text-center mt-4 ">
                    <h2 class="mb-3">{{$t('refer_Refera')}} {{$t('refer_friend')}}</h2>
                    <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                </div>  
                 <div class="CustomBlockWidth inMiddle-area mb-4" v-if="!congoDiv">
                    <div class="row justify-content-center">
                        <div class=" middleBox ">
                            <div class="position-relative" >
                                <div  v-for="key,index in email">
                                    <div class="form-group d-flex w-100 mb-0 ">
                                        <div class="field-wrapper w-100">
                                            <input placeholder=" " type="text" :id="'email'+index" v-model="email[index]"  v-validate="'email'" :name="'email'+index" class="float-field form-control"  :class="{ 'is-invalid':  submitted && errors.has('email'+index) }" :ref="'email'+index+'Input'" />
                                            <label for="password" class="float-label">{{$t('refer_referEmail')}}</label>
                                            <feather type="x" @click.prevent="email.splice(index, 1)" v-if="index != 0"/>
                                        </div>
                                    </div>
                                    
                                    <ul v-if="submitted"><li v-for="error in errors.collect('email'+index)" class="text-danger">{{ error.replace('email'+index, "Email") }}</li></ul>
                                </div>
                                <span class="common_btn btn_xs darkBG d-flex plusIcon" v-if="email.length < 5" @click.prevent="email.push('')">{{$t('refer_addmore')}}<feather type="plus-circle"/></span>
                            </div>
                            <div class="text-center ml-3">
                                <!--  <a href="#" v-if="get_user.profile.firstname != '' && get_user.mobile_no == ''" @click.prevent="mobileShowvar = false" class="mr-3">skip</a> -->
                                <button class="common_btn btn_sm" v-on:click.prevent="submit()">{{$t('refer_nowrefer')}}</button>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="CustomBlockWidth inMiddle-area radius whitebox p-4 text-center" v-if="congoDiv">
                    <span class="checkIcon mb-3"><feather type="check"></feather></span>
                    <h3 class="mb-3">{{$t('refer_successRefer')}}</h3>
                    <div class="text-center">
                        <a href="#" @click.prevent="congoDiv = false; email = ['']; submitted = false" class="mr-3 prism_btn btn_sm darkBG">{{$t('refer_refrMore')}}</a>
                        <router-link to="/dashboard" class="prism_btn btn_sm">{{$t('refer_godashboard')}}</router-link>
                    </div> 
                </div> 
            </div>
            <section class="partnershipProgram mt-5 pt-3 mb-3" v-if="referList.length == 0">
                <div class="row justify-content-center ">
                    <div class="col-lg-8">
                        <h2 class="text-center">{{$t('refer_partnerprog')}}</h2> 
                        <div class="row mt-5">
                            <div class="col-md-6">
                                <div class="card-body border-0 p-0">
                                    <div class="card-body border-0 p-3 partnershipArea ">
                                        <figure class="text-center" ><img src="/static/fxView/images/Affiliate.png" alt="Banner" class="Affiliate-icon"></figure>
                                        <div>
                                            <h3>{{$t('refer_Affilialte')}}</h3>
                                            <ul class="py-3">
                                                <li>{{$t('refer_uniquelink')}}</li>
                                                <li>{{$t('refer_trackearn')}}</li>
                                                <li>{{$t('refer_monitorStatus')}}</li>
                                                <li>{{$t('refer_withdrawearn')}}</li>
                                            </ul>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <a :href="$env_var.affiliateLink" class="greenBG" target="_blank">{{$t('refer_register')}}</a>
                                                <a :href="$env_var.knowMoreAffiliateLink" class="darkBG" target="_blank">{{$t('refer_knowmore')}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card-body border-0 p-0">
                                    <div class="card-body border-0 p-3 partnershipArea ">
                                        <figure class="text-center" ><img src="/static/fxView/images/Introducing.png" alt="Banner" class="Affiliate-icon"></figure>
                                        <div>
                                            <h3>{{$t('refer_brokerprogram')}}</h3>
                                            <ul class="py-3">
                                                <li>{{$t('refer_uniqueIB')}}</li>
                                                <li>{{$t('refer_IBmanager')}}</li>
                                                <li>{{$t('refer_controlearn')}}</li>
                                                <li>{{$t('refer_regislink')}}</li>
                                            </ul>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <a :href="$env_var.ibLink" class="greenBG" target="_blank">{{$t('refer_register')}}</a>
                                                <a :href="$env_var.knowMoreLink" class="darkBG" target="_blank">{{$t('refer_knowmore')}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div> 
        <section class="ClientsProgram mt-4 pt-3 mb-3" v-if="referList.length > 0">
            <div class="row no-gutters ">
                <div class="col-lg-12">
                    <h2 class=" mb-3">{{$t('refer_clientlist')}}</h2> 
                    <div class="inMiddle-area table-responsive">
                        <table class="table pmmTable">
                            <thead>
                                <tr>
                                    <th>{{$t('refer_email')}}</th> 
                                    <th>{{$t('refer_accountStatus')}}</th> 
                                    <th>{{$t('refer_volumereq')}}</th> 
                                    <th>{{$t('refer_tradedvol')}}</th> 
                                    <th>{{$t('refer_qualified')}}</th> 
                                    <!-- <th>{{$t('refer_action')}}</th>  -->
                                </tr>
                            </thead> 
                            <tbody>
                                <tr v-for="list in referList">
                                    <td>{{list.email || '-'}}</td>
                                    <td>{{list.stage }}</td> 
                                    <td>-</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <!-- <td><feather type="x-circle" @click.prevent="emailData = list" v-if="parseInt(list.is_registered) == 0"></feather><p v-else>-</p></td> -->
                                </tr>
                            </tbody>
                            <!-- <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="'4'" :list="referList.length" v-if="referList.length == 0"></loader-component> -->
                        </table>
                    </div>
                </div>
            </div>   
        </section>
        <!-- <div class=" modal-popup " v-if="Object.keys(emailData).length > 0">
            <div class="row w-100 justify-content-center align-items-center">
                <div class=" mb-3  middleBox">
                	<div class="customPp">
                        <button @click.prevent="emailData = {}" type="button" class="close d-flex align-items-center justify-content-center" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                	<div class="whiteBG px-4 py-5">
                		<div class="CustomBlockWidth inMiddle-area radius whitebox p-4 text-center" v-if="congoDelEmail">
		                    <span class="checkIcon mb-3"><feather type="check"></feather></span>
		                    <h3 class="mb-3">{{$t('refer_successDelete')}} <span class="green">{{emailData.email}}</span> {{$t('refer_fromReflist')}}</h3>
		                </div>
                        <div class="slctcurrency" v-else>
                            <h4 class="mb-3">{{$t('refer_wantTodelete')}} <span class="green">{{emailData.email}}</span> {{$t('refer_fromReflist')}}</h4> 
                        </div>
	                    <div class="full-width submitButton justify-content-center align-items-center  d-flex  mt-3 w-100" v-if="!congoDelEmail">
	                        <button class="prism_btn btn_sm" @click.prevent="deleteRef(emailData.id)" :class="(pageLoader)?'disabled':''"> {{$t('refer_confrm')}}</button>
	                    </div>
                    </div>
                </div>
            </div>
        </div>   -->         
    </div>
</template>
<script>
    export default {
        name: 'refer-a-friend',
        data() {
            return {
                mszValidation : '',
                pageLoader : false,
                email: [''],
                submitted: false,
                response_msg: '',
                msg_type: '',
                congoDiv: false,
                emailData : {},
                congoDelEmail: false
            }
        },
		methods:{
            toDivElement(id){
                var elmnt = document.getElementById(id);
                elmnt.scrollIntoView();
                document.getElementById(id).focus();
                // var element = document.getElementById("mainContentOuter")
                // console.log(element.scrollTop,element)
                // var top = element.scrollTop
                // console.log(top,1)
                // element.scrollTop = (top+180)
                // console.log(element.scrollTop,2)
            },
            deleteRef(id){
                this._runRefferDelete({ 'globalParams' : { 'id':id}, 'localParams' : {'parameter' : this} })
            },
            submit(){
                const _that = this
                _that.submitted = true;
                let email = this.email.filter(val=>val)
                _that.$validator.validate().then(valid => {
                    if (valid && email.length) {
                        _that.response_msg = ''
                        _that.msg_type = ''
                        let accountJson={
                            'globalParams' : {
                                emailArray : email
                            },
                            'localParams' : {'parameter' : _that}
                        }
                        _that._runRefferFriend(accountJson)
                    }else if(email.length == 0){
                        _that.response_msg = this.$t('refer_enterEmailrefer')
                        _that.msg_type = this.$t('refer_error')
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            list(){
                this._runGetRefferList({ 'globalParams' : {}, 'localParams' : {'parameter' : this, 'loaderFuncRun' : this.loaderFuncRun} })
            }
        },
        created(){
            if(this.referList.length > 0){
                this.loaderFuncRun = '0'
            }
            this.list()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/refer-a-friend.vue